import React, { useState, useEffect } from 'react';
import BudgetChargeTable from './BudgetChargeTable';
import { clearGoals, getGoalsAll } from '../../flux/actions/goalActions';
import { getGoal_societe_defaults } from '../../flux/actions/goalsocietedefaultActions';
import { getSocietes } from '../../flux/actions/societeActions';
import { getSummaryProjectBudget, clearVentes } from '../../flux/actions/venteActions';
import { getSummaryProjectAssociationsBudget, clearAssociations } from '../../flux/actions/associationActions';
import { getSummaryProjectBudgetEnc, clearEncaissements } from '../../flux/actions/encaissementActions';
import { getUsers } from '../../flux/actions/userActions';
import { Container, Row, Col, Label, CustomInput, Collapse } from 'reactstrap';

import { connect } from 'react-redux';
import { IBudgetChargeContainer, IBudgetChargeReduxProps } from '../../types/interfaces';
import Select from 'react-select';
import MonthPicker from 'react-month-picker'
import LoadingPage from '../../pages/loading';
import { constants } from '../../types/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faDesktop, faBullseye, faCaretLeft, faCaretRight, faWallet, faChartArea, faCalendarAlt, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import Loading from '../Loading';
import { beautifyName } from '../../services/misc';
import moment from 'moment';

const BudgetChargeContainerComponent = ({
  getGoalsAll,
  clearGoals,
  getGoal_societe_defaults,
  getSocietes,
  getSummaryProjectBudget,
  clearVentes,
  getSummaryProjectAssociationsBudget,
  clearAssociations,
  getSummaryProjectBudgetEnc,
  clearEncaissements,
  getUsers,
  goal,
  goal_societe_default,
  societe,
  vente,
  association,
  encaissement,
  user,
  auth
 }: IBudgetChargeContainer) => {
  const { goals, loading: loadingG } = goal;
  const { goal_societe_defaults, loading: loadingGSD } = goal_societe_default;
  const { societes, loading: loadingS } = societe;
  const { ventes, loading: loadingV } = vente;
  const { associations, loading: loadingA } = association;
  const { encaissements, loading: loadingE } = encaissement;
  const { users, loading: loadingU } = user;
  const [ventesAndAssociations, setVentesAndAssociations] = useState<any[]>([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
    if(!a.createdAt && !b.createdAt)
      return 0
    else if(!a.createdAt)
      return 1
    else if(!b.createdAt)
      return -1
    else
      return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  }));
  const [tableData, setTableData] = useState<any[]>([]);
  const [calculateParts, setCalculateParts] = useState(true);
  const projectDetails = societes.filter(e => e.LIBELE !== "CM3" && e.LIBELE !== "CM3 SOCIAL").map(e => ({projectName: e.LIBELE, projectId: e.id}));
  const budgetTypeOptions = [{value: "budget", label: "Budget Président"}, {value: "goal", label: "Budget Commercial"}];
  const [budgetTypeValue, setBudgetTypeValue] = useState<any>(budgetTypeOptions.find(e => e.value === "budget"));
  const societeOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  // const societeOptions = societes.map(e => ({value: e, label: e.LIBELE}));
  const [societesValue, setSocietesValue] = useState<any[]>([]);
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions.filter(e => ["NOT YET", "CHEZ", "EN COURS", "SIGNE"].includes(e.value)));
  const today = new Date();
  // const [yearValue, setYearValue] = useState<any>(today.getFullYear());
  const [monthPickerValue, setMonthPickerValue] = useState({ year: today.getFullYear(), month: today.getMonth() + 1 });
  const monthPickerRef = React.useRef<any>(null);
  const [moreSettings, setMoreSettings] = useState(false);
  
  useEffect(() => {
    getGoalsAll();
  }, [getGoalsAll]);
  
  useEffect(() => {
    getGoal_societe_defaults();
  }, [getGoal_societe_defaults]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    if(!societesValue?.length && societes && societes.length){
      if(auth && auth.user){
        for(let so of societes)
          if(so.id == auth.user.last_societe){
            setSocietesValue([so]);
            break
          }
      }
    }
  }, [societes]);

  useEffect(() => {
    clearVentes();
    clearAssociations();
    if(auth?.user){
      getSummaryProjectBudget(calculateParts ? 1 : 0);
      if(calculateParts)
        getSummaryProjectAssociationsBudget();
    }
  }, [auth, calculateParts]);

  useEffect(() => {
    getSummaryProjectBudgetEnc()
  }, [getSummaryProjectBudgetEnc]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
      clearEncaissements();
    }
  }, []);

  const getVentesFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => {
      const createdAt = e.isAssLine ? e.originalDate : e.DATE_RESERV;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  const getEncaissementsFromMonth = (encaissements, month, year) => {
    return encaissements.filter(e => {
      const createdAt = e.createdAt;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  const getLivraisonsFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => (e.isAssLine ? e.contrat : e)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || (e.isAssLine ? e.contrat : e)?.en_cours_signature == 1 || (e.isAssLine ? e.contrat : e)?.chez_notaire == 1).filter(e => {
      const dates = [(e.isAssLine ? e.contrat : e)?.chez_notaire == 1 && (e.isAssLine ? e.contrat : e)?.chez_notaire_date, (e.isAssLine ? e.contrat : e)?.en_cours_signature == 1 && (e.isAssLine ? e.contrat : e)?.en_cours_signature_date, (e.isAssLine ? e.contrat : e)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE && (e.isAssLine ? e.contrat : e)?.bien?.signe_notaire_date].filter(e => !!e)
      const signedAt = dates.length > 0 ? moment.min(dates.map(e => moment(e))).toDate() : undefined;
      return signedAt && (new Date(signedAt).getMonth() + 1) === month && (new Date(signedAt).getFullYear()) === year
    })
    // }).filter((e, i, a) => !e.isAssLine || i === 0 || a.findIndex(t => t.contrat?.id === e.contrat?.id) === i)
  }

  const getGoalsFromDateProjUser = (userId: number, societeId: any, month: number, year: number) => {
    let res: any = goals.find(e => e.comId === userId && e.societeId === societeId && e.month === month && e.year === year);
    if(!res)
      res = goal_societe_defaults.find(e => e.societeId === societeId && e.month === month && e.year === year)
    
    return res
  }

  const getGoalsFromDateUserAllProj = (userId: number, societeIds: number[], month: number, year: number) => {
    let totalGoals
    for(let i in societeIds){
      let res: any = goals.find(e => e.comId === userId && e.societeId === societeIds[i] && e.month === month && e.year === year);
      if(!res)
        res = goal_societe_defaults.find(e => e.societeId === societeIds[i] && e.month === month && e.year === year)
      
      if(!res)
        continue
      if(!totalGoals)
        totalGoals = res
      else{
        totalGoals.goalV = Number(totalGoals.goalV || 0) + Number(res.goalV || 0)
        totalGoals.goalE = Number(totalGoals.goalE || 0) + Number(res.goalE || 0)
        totalGoals.goalR = Number(totalGoals.goalR || 0) + Number(res.goalR || 0)
        totalGoals.goalL = Number(totalGoals.goalL || 0) + Number(res.goalL || 0)
      }
    }
    return totalGoals
  }

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .filter(e => titledValue?.value === "ALL" || (titledValue?.value === "TITLED" ? !!(e["isAssLine"] ? e["contrat"]?.bien : e["bien"])?.TF : !(e["isAssLine"] ? e["contrat"]?.bien : e["bien"])?.TF))
    .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !!(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !!(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || (e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]))
    .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      // .filter(e => includeSigneNotaire || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      .filter(e => (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3" && (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3 SOCIAL")
      .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations, sNotaireValues, titledValue]);

  useEffect(() => {
    // console.log("ventesAndAssociations", ventesAndAssociations)
    // console.log("encaissements", encaissements)
    if(societesValue?.length){
      const worksatUsers = users.filter(e => e.worksatProjects?.find(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === t.id) : societesValue.find(e => e.id === t.id)))
      const res = worksatUsers.map(n => ({
        userId: n.id,
        userName: beautifyName(n.given_name, n.surname),
        ...constants.DP_MONTHS.map((_, i) => ({
          lsPrixNet: getVentesFromMonth(ventesAndAssociations.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === (t.isAssLine ? t.contrat : t)?.IDPROJET) : societesValue.find(e => e.id === (t.isAssLine ? t.contrat : t)?.IDPROJET)).filter(t => /*(t.isAssLine ? t.contrat : t)?*/t.commissionedTo === n.id), i + 1, monthPickerValue?.year),
          lsEncaissements: getEncaissementsFromMonth(encaissements.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === t.IDPROJET) : societesValue.find(e => e.id === t.IDPROJET)).filter(t => t.ID_COM === n.id), i + 1, monthPickerValue?.year).filter(e => e.enc_supp !== 1),
          lsRecouvrement: getEncaissementsFromMonth(encaissements.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === t.IDPROJET) : societesValue.find(e => e.id === t.IDPROJET)).filter(t => t.ID_COM === n.id), i + 1, monthPickerValue?.year).filter(e => e.enc_supp === 1),
          lsLivraison: getLivraisonsFromMonth(ventesAndAssociations.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === (t.isAssLine ? t.contrat : t)?.IDPROJET) : societesValue.find(e => e.id === (t.isAssLine ? t.contrat : t)?.IDPROJET)).filter(t => /*(t.isAssLine ? t.contrat : t)?.*//*charge_bien_id*/t.commissionedTo === n.id), i + 1, monthPickerValue?.year),
          userGoal: societesValue.find(e => e.id === "ALL") ? getGoalsFromDateUserAllProj(n.id || -1, (n.worksatProjects || []).map(e => e.id), i + 1, monthPickerValue?.year) : getGoalsFromDateUserAllProj(n.id || -1, (societesValue || []).map(e => e.id), i + 1, monthPickerValue?.year),
        })).map((e, i) => ({
          sPrixNet: e.lsPrixNet.reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
          sEncaissements: e.lsEncaissements.reduce((e, t) => e + Number(t.MONTANT || 0), 0),
          sRecouvrement: e.lsRecouvrement.reduce((e, t) => e + Number(t.MONTANT || 0), 0),
          sLivraison: e.lsLivraison.reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
          // sLivraison: e.lsLivraison.reduce((e, t) => e + Number((t.isAssLine ? t.contrat : t)?.PRIX_NET || 0), 0),
          vIds: {venteIds: e.lsPrixNet.filter(e => !e.isAssLine).map(e => e.id), assIds: e.lsPrixNet.filter(e => !!e.isAssLine).map(e => e.id)},
          eIds: e.lsEncaissements.map(e => e.id),
          rIds: e.lsRecouvrement.map(e => e.id),
          lIds: {venteIds: e.lsLivraison.filter(e => !e.isAssLine).map(e => e.id), assIds: e.lsLivraison.filter(e => !!e.isAssLine).map(e => e.id)},
          // lIds: e.lsLivraison.map(e => (e.isAssLine ? e.contrat : e)?.id),
          // goalV: budgets.find(e => e.month === (i + 1) && e.year === monthPickerValue?.year && e.societeId === n.projectId)?.goalV,
          // goalE: budgets.find(e => e.month === (i + 1) && e.year === monthPickerValue?.year && e.societeId === n.projectId)?.goalE,
          // goalR: budgets.find(e => e.month === (i + 1) && e.year === monthPickerValue?.year && e.societeId === n.projectId)?.goalR,
          // goalL: budgets.find(e => e.month === (i + 1) && e.year === monthPickerValue?.year && e.societeId === n.projectId)?.goalL,
          goalV2: Number(e.userGoal?.goalV || 0),
          goalE2: Number(e.userGoal?.goalE || 0),
          goalR2: Number(e.userGoal?.goalR || 0),
          goalL2: Number(e.userGoal?.goalL || 0),
          month: i + 1,
          year: monthPickerValue?.year,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      }))
      const others = {
        userId: "OTHER",
        userName: "Autres",
        ...constants.DP_MONTHS.map((_, i) => ({
          lsPrixNet: getVentesFromMonth(ventesAndAssociations.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === (t.isAssLine ? t.contrat : t)?.IDPROJET) : societesValue.find(e => e.id === (t.isAssLine ? t.contrat : t)?.IDPROJET)).filter(t => !worksatUsers.find(e => e.id == t?.commissionedTo)), i + 1, monthPickerValue?.year),
          lsEncaissements: getEncaissementsFromMonth(encaissements.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === t.IDPROJET) : societesValue.find(e => e.id === t.IDPROJET)).filter(t => !worksatUsers.find(e => e.id == t.ID_COM)), i + 1, monthPickerValue?.year).filter(e => e.enc_supp !== 1),
          lsRecouvrement: getEncaissementsFromMonth(encaissements.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === t.IDPROJET) : societesValue.find(e => e.id === t.IDPROJET)).filter(t => !worksatUsers.find(e => e.id == t.ID_COM)), i + 1, monthPickerValue?.year).filter(e => e.enc_supp === 1),
          lsLivraison: getLivraisonsFromMonth(ventesAndAssociations.filter(t => societesValue.find(e => e.id === "ALL") ? societes.find(n => n.id === (t.isAssLine ? t.contrat : t)?.IDPROJET) : societesValue.find(e => e.id === (t.isAssLine ? t.contrat : t)?.IDPROJET)).filter(t => !worksatUsers.find(e => e.id == t?.commissionedTo)), i + 1, monthPickerValue?.year),
        })).map((e, i) => ({
          sPrixNet: e.lsPrixNet.reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
          sEncaissements: e.lsEncaissements.reduce((e, t) => e + Number(t.MONTANT || 0), 0),
          sRecouvrement: e.lsRecouvrement.reduce((e, t) => e + Number(t.MONTANT || 0), 0),
          sLivraison: e.lsLivraison.reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
          vIds: {venteIds: e.lsPrixNet.filter(e => !e.isAssLine).map(e => e.id), assIds: e.lsPrixNet.filter(e => !!e.isAssLine).map(e => e.id)},
          eIds: e.lsEncaissements.map(e => e.id),
          rIds: e.lsRecouvrement.map(e => e.id),
          lIds: {venteIds: e.lsLivraison.filter(e => !e.isAssLine).map(e => e.id), assIds: e.lsLivraison.filter(e => !!e.isAssLine).map(e => e.id)},
          goalV2: 0,
          goalE2: 0,
          goalR2: 0,
          goalL2: 0,
          month: i + 1,
          year: monthPickerValue?.year,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      }
      const resAndOthers = [...res, others]
      setTableData([...resAndOthers, {
        userId: "ALL",
        userName: "TOTAL",
        ...constants.DP_MONTHS.map((e, i) => ({
          sPrixNet: resAndOthers.reduce((e, t) => e + Number(t[i + 1].sPrixNet || 0), 0),
          sLivraison: resAndOthers.reduce((e, t) => e + Number(t[i + 1].sLivraison || 0), 0),
          sEncaissements: resAndOthers.reduce((e, t) => e + Number(t[i + 1].sEncaissements || 0), 0),
          sRecouvrement: resAndOthers.reduce((e, t) => e + Number(t[i + 1].sRecouvrement || 0), 0),
          vIds: {venteIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].vIds?.venteIds || [])], [] as any[]), assIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].vIds?.assIds || [])], [] as any[])},
          eIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].eIds || [])], [] as any[]),
          rIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].rIds || [])], [] as any[]),
          // lIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].lIds || [])], [] as any[]),
          lIds: {venteIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].lIds?.venteIds || [])], [] as any[]), assIds: resAndOthers.reduce((e, t) => [...e, ...(t[i + 1].lIds?.assIds || [])], [] as any[])},
          goalV2: res.reduce((e, t) => e + Number(t[i + 1].goalV2 || 0), 0),
          goalE2: res.reduce((e, t) => e + Number(t[i + 1].goalE2 || 0), 0),
          goalR2: res.reduce((e, t) => e + Number(t[i + 1].goalR2 || 0), 0),
          goalL2: res.reduce((e, t) => e + Number(t[i + 1].goalL2 || 0), 0),
          month: i + 1,
          year: monthPickerValue?.year,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      }])
    }
    else
      setTableData([])
  }, [societesValue?.length, societes?.length, ventesAndAssociations, encaissements, monthPickerValue])
  
  const handleBudgetTypeChange = data => {
    setBudgetTypeValue(data || '');
  }

  const changeCalculatePartsHandle = (e) => {
    setCalculateParts(e.target.checked);
  };

  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }
  
  const showMonthPicker = () => {
    if(monthPickerRef?.current)
      monthPickerRef.current.show()
  };

  const handlePickerChange = (year, month) => {
    setMonthPickerValue({ year, month });
    if(monthPickerRef?.current)
      monthPickerRef.current.dismiss()
  };
  
  const handleSocieteChange = data => {
    setSocietesValue(data?.length ? data.map(e => e.value) : []);
  }

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  useEffect(() => {
    console.log({societesValue})
  }, [societesValue])
  
  return loadingG ? <LoadingPage/> : (
    <>
      <Container>
        <Row>
          <Col xs="12" lg="6"><h3 className="title"><FontAwesomeIcon icon={faBullseye} />&nbsp;&nbsp;Objectif - Commerciaux</h3></Col>
          <Col xs="12" lg="6" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="societe">Projet : </Label>
            </div>
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              isMulti
              value={societesValue?.map(e => ({label: societes.find(t => t.id === e.id)?.LIBELE || "", value: e})) || []}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={false}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              isDisabled={loadingV || loadingA || loadingE}
              // valueKey='code'
              options={societeOptions}
              // filterOption={filterOptions}
            />
          </Col>
        </Row>
        <div className="moreSettings" style={{padding: 0, fontSize: "small"}}>
          <p onClick={() => setMoreSettings(e => !e)} style={{marginBottom: "5px"}}><FontAwesomeIcon icon={faAngleDoubleDown} className={`flipIcon${moreSettings ? " flipped" : ""}`} />&nbsp;&nbsp;Plus de paramètres</p>
        </div>
        <Collapse className="mb-2" isOpen={moreSettings}>
          <Row>
            <Col sm="12" lg="6" className="listPageFilterSelect">
              <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
                <Label for="snotaire">Statut notaire : </Label>
              </div>
              <Select
                id="snotaire"
                className="reactselect"
                classNamePrefix="react-select"
                isMulti
                value={sNotaireValues?.map(e => ({label: e.label, value: e.value})) || []}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleSNotaireChange}
                placeholder={'Chercher...'}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                options={sNotaireOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </Col>
            <Col xs="12" lg="3" className="listPageFilterSelect">
              <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
                <Label for="titled">Titrés : </Label>
              </div>
              <Select
                id="titled"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={titledOptions[1]}
                value={titledValue}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleTitledChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={false}
                options={titledOptions}
              />
            </Col>
            <Col xs="12" lg="3" className="fullFlexCenter text-lg-center justify-content-center justify-content-lg-end">
              <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Ne prendre en compte que les parts vendues si association" checked={calculateParts} onChange={changeCalculatePartsHandle} />
            </Col>
          </Row>
        </Collapse>
      </Container>
      <Container>
        <Row>
          <Col xs="12" className="text-center">
            <h3 className="fullFlexCenter" style={{letterSpacing: "8px", fontFamily: "'Ultra', sans-serif", color: "darkslategray", ...(loadingV || loadingA || loadingE ? {opacity: .3, pointerEvents: "none"} : {})}}>
              <MonthPicker
                ref={monthPickerRef}
                // years={[2008, 2011, 2012, 2014, 2016, 2018, 2020]}
                years={{min: 2010, max: 2069}}
                value={monthPickerValue}
                key={JSON.stringify(monthPickerValue)}
                lang={constants.MONTHS_ABBRV}
                onChange={handlePickerChange} >
                <div style={{cursor: "pointer"}} onClick={showMonthPicker} title="Changer la date">{constants.DP_MONTHS[monthPickerValue.month - 1]}&nbsp;{monthPickerValue.year}&nbsp;<FontAwesomeIcon icon={faCalendarAlt} /></div>
              </MonthPicker>
            </h3>
          </Col>
        </Row>
      </Container>
      {/* <div className="fullFlexCenter">
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretLeft} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) - 1)} title={`${Number(yearValue) - 1}`} /></div>
        <div className="goalCalendarYear">{yearValue}</div>
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretRight} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) + 1)} title={`${Number(yearValue) + 1}`} /></div>
      </div> */}
      {loadingV && loadingE ? <Loading topSpace /> : <BudgetChargeTable linesData={tableData} month={monthPickerValue?.month || -1} societesValue={societesValue} encaissements={encaissements} loadingV={loadingV} loadingA={loadingA} loadingE={loadingE} />}
    </>
  );
};

const mapStateToProps = (state: IBudgetChargeReduxProps) => ({
  goal: state.goal,
  goal_societe_default: state.goal_societe_default,
  societe: state.societe,
  vente: state.vente,
  association: state.association,
  encaissement: state.encaissement,
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getGoalsAll, clearGoals, getGoal_societe_defaults, getSocietes, getSummaryProjectBudget, clearVentes, getSummaryProjectAssociationsBudget, clearAssociations, getSummaryProjectBudgetEnc, clearEncaissements, getUsers })(BudgetChargeContainerComponent);
